"use client"

import React, { useEffect } from "react"
import { Helmet } from "react-helmet-async"

export default function Gallery() {
  // Disable global background pattern ONLY for this page
  useEffect(() => {
    // Save previous body styles
    const prevBackground = document.body.style.background
    const prevBgColor = document.body.style.backgroundColor
    const prevBlend = document.body.style.backgroundBlendMode
    const prevAttachment = document.body.style.backgroundAttachment

    // Force white background
    document.body.style.background = "none"
    document.body.style.backgroundColor = "#ffffff"
    document.body.style.backgroundBlendMode = "normal"
    document.body.style.backgroundAttachment = "scroll"

    return () => {
      // Restore previous body styles
      document.body.style.background = prevBackground
      document.body.style.backgroundColor = prevBgColor
      document.body.style.backgroundBlendMode = prevBlend
      document.body.style.backgroundAttachment = prevAttachment
    }
  }, [])

  const galleryImages = [
    "DSC01814.JPG",
    "DSC01843.JPG",
    "DSC01893.JPG",
    "DSC01912.JPG",
    "DSC01913.JPG",
    "DSC01916.JPG",
    "DSC01959.JPG",
    "DSC01978.JPG",
    "DSC02004.JPG",
    "DSC02025.JPG",
    "DSC02034.jpg",
    "DSC02043.jpg",
    "DSC02058.jpg",
    "DSC02062.jpg",
    "DSC02076.jpg",
    "DSC02078.jpg",
    "DSC02094.jpg",
    "DSC02101.jpg",
    "DSC02139.jpg",
    "DSC02168.jpg",
    "DSC02180.jpg",
    "DSC02184.jpg",
    "DSC02187.jpg",
    "DSC02197.jpg",
    "DSC02213.jpg",
    "DSC02220.jpg",
    "DSC02222.jpg",
    "DSC02226.jpg",
    "DSC02233.jpg",
    "DSC02236.jpg",
    "DSC02247.jpg",
    "DSC02251.jpg",
    "DSC02252.jpg",
    "DSC02261.jpg",
    "DSC02278.jpg",
    "DSC02283.jpg",
    "DSC02286.jpg",
    "DSC02292.jpg",
    "DSC02298.jpg",
    "DSC02302.jpg",
    "DSC02314.jpg",
    "DSC02326.jpg",
  ]

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Our Gallery | Africa Maritime Talent</title>
        <meta
          name="description"
          content="Browse through our gallery to see highlights from our events and activities in the maritime industry."
        />
      </Helmet>

      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Our Gallery
            </h1>
            <div className="w-20 h-1 bg-primary-orange mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Explore moments from our events, training sessions, and activities
              in the maritime industry.
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 aspect-w-1 aspect-h-1"
              >
                <img
                  src={`/assets/gallery/${image}`}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />

                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                  <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <svg
                      className="w-10 h-10"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 0 0114 0z"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
